module.exports = __webpack_public_path__ + "img/sovalis-poulpy.b0fce5f9.png";